

let Node = (_id,_parentid,_data,_level,_parent) => {
    return {
        id:_id,
    parentid:_parentid,
    data: _data,
    children : [],
    level :_level,
    parent : _parent
}
};
const StateTree = () => {
        this.root = undefined;// = new Node();
        this.unassignedNodes = {};
};

const traverse = (node, callback,tag)  => {
    if(node !== undefined)
    {
        callback(node,tag);
        for(var i in node.children)
        {
            traverse(node.children[i],callback,tag);
        }
    }

};
const search=(tree, _id) => {
    let _node = undefined;
    traverse(tree.root,function(node){
        if(node.id === _id)
        {
            _node = node;
            return false;

        }
    });
    return _node;
};
const addNode=(tree, _parentid,_id,_data,cb) => {
    tree.unassignedNodes = tree.unassignedNodes || {};
    let added = false;
    if(_id === undefined)
    {
        throw new Error('Error: A node must have an id');
    }
    if((_parentid === undefined || _parentid === -1 || _parentid === "") && tree.root === undefined)
    {
        //console.log("ny rot: "+_id);
        tree.root =  Node(_id,_parentid,_data,0,undefined);
    }
    else
    {
        traverse(tree.root,(node) => {
            if(node.id === _parentid)
            {
                // node.children[_id] = new Node(_id,_parentid,_data);
                //console.log(_id+" er barn av "+_parentid);
                _data.parent = node.data;
                let newNode = Node(_id,_parentid,_data,node.level+1,node);
                node.children.push(newNode);
                added = true;
                if(cb)
                    cb(newNode);
                return false;
            }
        });
        if(!added)
        {
            tree.unassignedNodes[_id] ={_parentid,_id,_data};

        }
        else{
            delete tree.unassignedNodes[_id];
        }
    }

    for(let i in tree.unassignedNodes)
    {

        if(added && _id === tree.unassignedNodes[i]._parentid) {
            addNode(tree, tree.unassignedNodes[i]._parentid,tree.unassignedNodes[i]._id,tree.unassignedNodes[i]._data,cb);
        }

    }

};
const remove=(tree, _id) => {
    let node = search(_id);
    if(node && node.parent) {
        node.parent.children.splice(node.parent.children.indexOf(node),1);
    }
};
const customSort = (tree, node,sortFunc) => {
    let temp = node.parent;
    if(temp && temp.children !== undefined) {
        temp.children.sort(sortFunc);
    }
};

module.exports = {
    StateTree,
    traverse,
    addNode,
    search
};


// WEBPACK FOOTER //
// ./src/modules/StateTree.js